export default "__VITE_PUBLIC_ASSET__935d4a38__"